"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _reactCopyToClipboard = require("react-copy-to-clipboard");

var _FormLabel = _interopRequireDefault(require("../FormLabel"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _Input = _interopRequireDefault(require("../Input"));

var PasswordDetail = function PasswordDetail(_ref) {
  var name = _ref.name,
      value = _ref.value;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var chunks = (0, _react.useMemo)(function () {
    return value.split(/(.{1,4})/g).filter(Boolean);
  }, [value]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      clicked = _useState2[0],
      setClicked = _useState2[1];

  function handleOnCopy() {
    setClicked(true);
    setTimeout(function () {
      return setClicked(false);
    }, 1500);
  }

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    className: "text-sm"
  }, t('settings.asp.form.appName.label')), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    standalone: true,
    disabled: true,
    value: name,
    className: "border-none w-full font-bold bg-secondary"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    className: "text-sm normal-case"
  }, t('settings.asp.detail.password.label')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_reactCopyToClipboard.CopyToClipboard, {
    text: value,
    onCopy: handleOnCopy
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full px-3 py-2 tracking-widest font-bold bg-secondary text-primary"
  }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: clicked ? t('button.copied') : t('settings.asp.detail.copy')
  }, /*#__PURE__*/_react["default"].createElement("div", null, chunks.map(function (chunk) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: chunk,
      className: "mx-1 first:ml-0 last:mr-0"
    }, chunk);
  }))))))));
};

var _default = PasswordDetail;
exports["default"] = _default;
//# sourceMappingURL=Detail.js.map